module.exports = __webpack_public_path__ + "static/img/445_phase_function_Paper_PointsHejduk_Prediction.23a0bb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/445_phase_function_Paper_PointsHejduk_Prediction.png
// module id = VzXh
// module chunks = 0